import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { auth, database } from "configs/firebaseConfigs";
import { onAuthStateChanged } from "firebase/auth";
import { onValue, ref } from "firebase/database";
import { useIsMounted } from "hooks";

const AppContext = createContext({});

const AppContextProvider = (props) => {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const isMounted = useIsMounted();

  const updateUser = useCallback(
    async (updatedUserData) => {
      isMounted.current &&
        setUser((prev) => ({
          ...prev,
          ...updatedUserData,
        }));
      setIsLoading(false);
    },
    [isMounted]
  );

  useEffect(() => {
    try {
      const onAuthStateChange = async () => {
        onAuthStateChanged(auth, (user) => {
          // signOut(auth);
          if (user) {
            onValue(ref(database, "users/" + user?.uid), (snapshot) => {
              if (snapshot.exists) {
                const data = snapshot.val();
                // console.log(data)
                updateUser({
                  displayName: data?.displayName,
                  uid: data?.uid,
                  createdAt: data?.createdAt,
                  lastSignIn: data?.lastLoginAt,
                  phoneNumber: data?.phoneNumber,
                  emailVerified: data?.emailVerified,
                  role: data?.role,
                  dateOfBirth: data?.dateOfBirth,
                  email: data?.email,
                  isBlocked: data?.isBlocked,
                  photoURL: data?.photoURL,
                  referralCode: data?.referralCode,
                  referred: data?.referred,
                  updatedAt: data?.lastLoginAt,
                  address: data?.address,
                });
              }
            });
          } else {
            updateUser({
              displayName: "",
              uid: "",
              createdAt: "",
              lastSignIn: "",
              phoneNumber: "",
              emailVerified: false,
              role: "user",
              dateOfBirth: "",
              email: "",
              isBlocked: true,
              photoURL: "",
              referred: [],
              updatedAt: "",
              address: [],
              referralCode: "",
            });
          }
        });
      };
      onAuthStateChange();
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted]);
  // console.log('is loading' + isLoading)
  return (
    <AppContext.Provider value={{ user, updateUser, isLoading }}>
      {props.children}
    </AppContext.Provider>
  );
};
export const useAppContext = () => useContext(AppContext);

export default AppContextProvider;
